import { render, staticRenderFns } from "./zhuanti-jujiao.vue?vue&type=template&id=e3af5b0e&"
import script from "./zhuanti-jujiao.vue?vue&type=script&lang=js&"
export * from "./zhuanti-jujiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports